import { FC } from 'react';
import { LessonData } from '../../../custom-hooks/useExitSlipChartValues';
import { format, parseISO } from 'date-fns';
import { Button } from 'primereact/button';
import { Pencil, Plus } from 'lucide-react';
import { ExitSlipModalType } from '../../../redux/reducers/exitSlipModalSlice';

interface Props {
  nextLesson: LessonData | null;
  classExitSlipsHasRecords: boolean;
  handleTriggerModal: (type: ExitSlipModalType) => void;
}

const buttonClass =
  '!tw-inline-flex !tw-h-10 !tw-shrink-0 !tw-items-center !tw-justify-center !tw-rounded-full !tw-font-atkinson !tw-text-sm !tw-font-bold !tw-leading-5 !tw-whitespace-nowrap tw-border-0';

const ExitSlipSnapshotBanner: FC<Props> = ({ nextLesson, classExitSlipsHasRecords, handleTriggerModal }) => {
  return (
    <div className="tw-flex tw-w-full tw-items-center tw-gap-3 tw-rounded-full tw-border-2 tw-border-b-4 tw-border-solid tw-border-neutral-100 tw-bg-white tw-py-4 tw-pl-6 tw-pr-4 tw-font-atkinson tw-text-sm tw-leading-5 tw-text-neutral-950">
      <p className="tw-m-0 tw-min-w-0 tw-flex-1 [text-wrap:pretty]">
        {nextLesson ? (
          <>
            <span className="tw-font-bold">Upcoming lesson: </span>
            Lesson {nextLesson.curriculumLesson.number} on {format(parseISO(nextLesson.dueOn), 'MMMM do')}
          </>
        ) : (
          <>
            <span className="tw-font-bold">Heads up! </span>
            You don’t have any upcoming tickets
          </>
        )}
      </p>
      {(nextLesson || classExitSlipsHasRecords) && (
        <Button
          outlined
          className={`${buttonClass} !tw-gap-3 !tw-border-2 !tw-px-3 !tw-text-indigo-600 hover:!tw-text-white`}
          icon={<Pencil size={18} />}
          label="Manage assigned tickets"
          onClick={() => handleTriggerModal(ExitSlipModalType.EDIT)}
        />
      )}
      <Button
        className={`${buttonClass} !tw-gap-2 !tw-border-none !tw-bg-indigo-600 hover:!tw-bg-indigo-700 focus:!tw-bg-indigo-700 !tw-px-4 !tw-shadow-[0_4px_4px_0_rgba(140,181,248,0.1)]`}
        icon={<Plus size={18} />}
        label="Assign more"
        onClick={() => handleTriggerModal(ExitSlipModalType.ASSIGN)}
      />
    </div>
  );
};

export default ExitSlipSnapshotBanner;
